import React, { useState } from 'react';
import api from '../services/api';

const Register = ({ onRegistered, onNavigate }) => {
  const [form, setForm] = useState({ name: '', tin: '', mobile: '', email: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (form.password !== form.confirmPassword) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await api.post('/auth/register', {
        name: form.name, tin: form.tin, mobile: form.mobile, email: form.email, password: form.password
      });
      setSuccess('Registration successful! Please login.');
      setForm({ name: '', tin: '', mobile: '', email: '', password: '', confirmPassword: '' });
      onRegistered && onRegistered();
      onNavigate && onNavigate('login');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    page: { minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto" },
    card: { width: '100%', maxWidth: 520, background: '#fff', borderRadius: 12, boxShadow: '0 8px 30px rgba(20, 30, 70, 0.06)', padding: 28, boxSizing: 'border-box' },
    header: { marginBottom: 12, textAlign: 'center' },
    title: { margin: 0, fontSize: 22, fontWeight: 800, color: '#0f172a' },
    subtitle: { marginTop: 6, color: '#6b7280' },
    form: { display: 'grid', gap: 12, marginTop: 12 }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Create account — Doc Sheba</h1>
          <div style={styles.subtitle}>Create your account to manage documents and connect with consultants</div>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={{ color: 'red' }}>{error}</div>}
          {success && <div style={{ color: 'green' }}>{success}</div>}

          <input name="name" placeholder="Full name" value={form.name} onChange={handleChange} required style={inputStyle} />
          <input name="tin" placeholder="TIN number" value={form.tin} onChange={handleChange} style={inputStyle} />
          <input name="mobile" placeholder="Mobile" value={form.mobile} onChange={handleChange} required style={inputStyle} />
          <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required style={inputStyle} />
          <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required style={inputStyle} />
          <input name="confirmPassword" type="password" placeholder="Confirm password" value={form.confirmPassword} onChange={handleChange} required style={inputStyle} />

          <div style={{ display: 'flex', gap: 8 }}>
            <button type="submit" disabled={loading} style={buttonStyle}>{loading ? 'Creating…' : 'Create account'}</button>
            <button type="button" onClick={() => onNavigate && onNavigate('login')} style={{ padding: '0.75rem 1rem', borderRadius: 8 }}>Back to login</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const inputStyle = { padding: '0.85rem', borderRadius: 8, border: '1px solid #e6eef8', fontSize: '1rem' };
const buttonStyle = { background: '#06b6d4', color: '#fff', border: 'none', borderRadius: 8, padding: '0.75rem 1rem', fontWeight: 700, cursor: 'pointer' };

export default Register;